"use strict";

// System Evolution interactive diagram. Renders components as nodes in horizontal
// layer bands, with association edges (components that co-change) drawn as SVG
// curves behind them. Hover/focus a node to trace its associations; click to open
// the component detail. Pure vanilla JS; HTML nodes + an SVG edge layer share the
// same coordinate space inside a position:relative root.

(function () {
  var SVGNS = 'http://www.w3.org/2000/svg';
  var CARD_W = 188, CARD_H = 64, GAP_X = 28, GAP_Y = 26, LABEL_H = 30, BAND_GAP = 14;

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function svgEl(tag, attrs) {
    var e = document.createElementNS(SVGNS, tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  // For a row of n items, return order[j] = the column for the j-th item, fanning
  // outward from the centre: [centre, centre+1, centre-1, centre+2, centre-2, ...].
  function centerOutOrder(n) {
    var center = Math.floor((n - 1) / 2);
    var order = [center];
    var step = 1;
    while (order.length < n) {
      if (center + step < n) order.push(center + step);
      if (order.length < n && center - step >= 0) order.push(center - step);
      step++;
    }
    return order;
  }

  function layout(canvas, data) {
    canvas.innerHTML = '';
    var W = Math.max(canvas.clientWidth || 0, 320);
    var cols = Math.max(1, Math.floor((W + GAP_X) / (CARD_W + GAP_X)));
    var pos = {};           // id -> {cx, cy, x, y}
    var nodeById = {};
    data.nodes.forEach(function (n) { nodeById[n.id] = n; });

    // Connection count per node, from the edges actually drawn — so the layout
    // reflects real degree (after any server-side pruning).
    var degree = {};
    data.nodes.forEach(function (n) { degree[n.id] = 0; });
    data.edges.forEach(function (e) {
      if (degree[e.source] != null) degree[e.source]++;
      if (degree[e.target] != null) degree[e.target]++;
    });

    // Place one row of items, horizontally centred, with the highest-priority item
    // in the middle fanning outward (centre-out). Writes into pos.
    function placeRow(items, rowY) {
      var rowW = items.length * CARD_W + (items.length - 1) * GAP_X;
      var startX = Math.max(0, (W - rowW) / 2);
      var order = data.centerOut ? centerOutOrder(items.length) : null;
      items.forEach(function (n, j) {
        var c = order ? order[j] : j;
        var x = startX + c * (CARD_W + GAP_X);
        pos[n.id] = { x: x, y: rowY, cx: x + CARD_W / 2, cy: rowY + CARD_H / 2 };
      });
    }

    var bands = [];
    var y = 0;
    data.layers.forEach(function (layer) {
      var members = data.nodes.filter(function (n) { return n.layer === layer.key; });
      if (!members.length) return;
      // Most-connected first, then packed into a pyramid: rows grow 1, 2, 3, ...
      // (capped at what fits the width) so the top hub sits alone at the apex and
      // each row below holds progressively more nodes, fanning edges downward.
      members = members.slice().sort(function (a, b) { return (degree[b.id] || 0) - (degree[a.id] || 0); });
      var bandTop = y;
      var rowY = bandTop + LABEL_H;
      var rowsUsed = 0;
      var i = 0;
      var cap = 1;
      while (i < members.length) {
        var take = Math.min(cap, cols, members.length - i);
        placeRow(members.slice(i, i + take), rowY);
        i += take;
        rowY += CARD_H + GAP_Y;
        rowsUsed++;
        cap = Math.min(cap + 1, cols);
      }
      var bandH = LABEL_H + rowsUsed * CARD_H + (rowsUsed - 1) * GAP_Y;
      bands.push({ layer: layer, top: bandTop, height: bandH });
      y = bandTop + bandH + BAND_GAP;
    });
    var totalH = y;

    // SVG edge layer (behind nodes)
    var svg = svgEl('svg', { 'class': 'se-edges', width: W, height: totalH });
    var maxW = 1;
    data.edges.forEach(function (e) { if (e.weight > maxW) maxW = e.weight; });
    var edgeEls = {};       // id -> [paths]
    data.nodes.forEach(function (n) { edgeEls[n.id] = []; });
    data.edges.forEach(function (e) {
      var a = pos[e.source], b = pos[e.target];
      if (!a || !b) return;
      var d;
      if (Math.abs(a.cy - b.cy) < 6) {
        var lift = a.cy - 38;                 // same band: gentle bow upward
        d = 'M' + a.cx + ',' + a.cy + ' C' + a.cx + ',' + lift + ' ' + b.cx + ',' + lift + ' ' + b.cx + ',' + b.cy;
      } else {
        var mid = (a.cy + b.cy) / 2;          // cross band: vertical S-curve
        d = 'M' + a.cx + ',' + a.cy + ' C' + a.cx + ',' + mid + ' ' + b.cx + ',' + mid + ' ' + b.cx + ',' + b.cy;
      }
      var p = svgEl('path', {
        'class': 'se-edge', d: d,
        'stroke-width': (1 + (e.weight / maxW) * 2.6).toFixed(2),
        'data-w': e.weight
      });
      svg.appendChild(p);
      edgeEls[e.source].push({ path: p, other: e.target });
      edgeEls[e.target].push({ path: p, other: e.source });
    });
    canvas.appendChild(svg);

    // Band labels
    bands.forEach(function (band) {
      if (!band.layer.label) return;
      var lab = el('div', 'se-band-label se-band-label--' + band.layer.key);
      lab.style.top = band.top + 'px';
      lab.textContent = band.layer.label;
      canvas.appendChild(lab);
    });

    // Nodes
    data.nodes.forEach(function (n) {
      var p = pos[n.id];
      if (!p) return;
      var attrs = { 'data-id': n.id, style: 'left:' + p.x + 'px;top:' + p.y + 'px;width:' + CARD_W + 'px;height:' + CARD_H + 'px' };
      if (!n.nolink) attrs.href = n.href || (data.base + '/evolution/component/' + n.id);
      // `updated` is server-stamped for window-scoped embeds (dashboard from/to);
      // bucketed pages instead toggle is-updated live via applyDiagram counts.
      var node = el(n.nolink ? 'div' : 'a',
        'se-node se-node--' + (n.kind || n.layer) + ' se-act-edge--' + n.activity + (n.nolink ? ' se-node--nolink' : '') + (n.updated ? ' is-updated' : ''),
        attrs);
      var name = el('span', 'se-node__name'); name.textContent = n.name;
      var meta = el('span', 'se-node__meta');
      meta.textContent = n.meta_text || (n.commits + ' commits · ' + n.file_count + ' files');
      var dot = el('span', 'se-node__dot se-act--' + n.activity);
      node.appendChild(dot);
      node.appendChild(name);
      node.appendChild(meta);

      function focus() {
        canvas.classList.add('is-focusing');
        node.classList.add('is-active');
        edgeEls[n.id].forEach(function (x) {
          x.path.classList.add('is-active');
          var nb = canvas.querySelector('.se-node[data-id="' + x.other + '"]');
          if (nb) nb.classList.add('is-neighbor');
        });
      }
      function blur() {
        canvas.classList.remove('is-focusing');
        canvas.querySelectorAll('.se-node.is-active,.se-node.is-neighbor').forEach(function (x) {
          x.classList.remove('is-active', 'is-neighbor');
        });
        canvas.querySelectorAll('.se-edge.is-active').forEach(function (x) { x.classList.remove('is-active'); });
      }
      node.addEventListener('mouseenter', focus);
      node.addEventListener('mouseleave', blur);
      node.addEventListener('focus', focus);
      node.addEventListener('blur', blur);
      canvas.appendChild(node);
    });

    canvas.style.height = totalH + 'px';
  }

  // Level-1 System Architecture diagram: draw the connector lines between the
  // four layer boxes (UI -> Business, Business -> Database, Business -> External).
  function initArch() {
    var root = document.querySelector('[data-se-arch]');
    if (!root) return;
    var grid = root.querySelector('.se-arch__grid');
    if (!grid) return;
    function box(key) { return grid.querySelector('.se-arch__box[data-key="' + key + '"]'); }
    function draw() {
      var old = grid.querySelector('.se-arch__svg');
      if (old) old.remove();
      var gr = grid.getBoundingClientRect();
      var svg = svgEl('svg', { 'class': 'se-arch__svg', width: grid.clientWidth, height: grid.clientHeight });
      [['ui', 'business'], ['business', 'data'], ['business', 'integrations']].forEach(function (c) {
        var a = box(c[0]), b = box(c[1]);
        if (!a || !b) return;
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        var x1 = ra.left + ra.width / 2 - gr.left, y1 = ra.bottom - gr.top;
        var x2 = rb.left + rb.width / 2 - gr.left, y2 = rb.top - gr.top;
        var my = (y1 + y2) / 2;
        var d = 'M' + x1 + ',' + y1 + ' C' + x1 + ',' + my + ' ' + x2 + ',' + my + ' ' + x2 + ',' + y2;
        var faded = a.classList.contains('se-arch__box--absent') || b.classList.contains('se-arch__box--absent');
        svg.appendChild(svgEl('path', { 'class': 'se-arch__edge' + (faded ? ' is-faded' : ''), d: d }));
      });
      grid.insertBefore(svg, grid.firstChild);
    }
    draw();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(draw, 150); });
  }

  // The active window is URL-driven (?since=<days>), set by the server from the
  // toolbar's data-se-days. This survives navigation and lets the detail pages
  // server-render the matching commit lists. Diagrams/cake switch live (no reload);
  // detail pages navigate.
  function initialDays() {
    var bar = document.querySelector('[data-se-range]');
    var d = bar ? parseInt(bar.getAttribute('data-se-days'), 10) : NaN;
    return isNaN(d) ? 30 : d;
  }
  function setActiveBtn(days) {
    var bar = document.querySelector('[data-se-range]');
    if (!bar) return;
    Array.prototype.forEach.call(bar.querySelectorAll('.se-range__btn'), function (b) {
      b.classList.toggle('is-active', (parseInt(b.getAttribute('data-days'), 10) || 0) === days);
    });
  }
  // Carry the active window onto every in-app Evolution link, so clicking through
  // to a layer or detail page keeps the same window without a reset.
  function decorateLinks(days) {
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/evolution"]'), function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      try {
        var u = new URL(href, window.location.origin);
        if (u.host !== window.location.host || u.pathname.indexOf('/evolution') === -1) return;
        u.searchParams.set('since', String(days));
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) { /* ignore */ }
    });
  }
  function withSince(days) {
    var u = new URL(window.location.href);
    u.searchParams.set('since', String(days));
    return u.pathname + u.search;
  }

  // Diagram nodes: light up (green) any component/table with a commit in the window
  // and rewrite its activity number to that window's count. Tool nodes (no counts)
  // keep their static label.
  function applyDiagram(canvas, data, days) {
    var byId = {};
    data.nodes.forEach(function (n) { byId[n.id] = n; });
    canvas.querySelectorAll('.se-node').forEach(function (nodeEl) {
      var n = byId[nodeEl.getAttribute('data-id')];
      if (!n || !n.counts) return;
      var c = n.counts[days] || 0;
      nodeEl.classList.toggle('is-updated', c > 0);
      var metaEl = nodeEl.querySelector('.se-node__meta');
      if (metaEl) metaEl.textContent = (n.files || 0) + ' files · ' + c + ' commits';
    });
  }

  // Cake (Level-1): light up each layer box with activity in the window and rewrite
  // its commits stat to that window's count.
  function applyCake(days) {
    document.querySelectorAll('.se-arch__box[data-counts]').forEach(function (box) {
      var counts;
      try { counts = JSON.parse(box.getAttribute('data-counts')); } catch (e) { return; }
      var c = counts[days] || 0;
      box.classList.toggle('is-updated', c > 0);
      var statEl = box.querySelector('[data-se-arch-commits]');
      if (statEl) statEl.textContent = c + ' commits';
    });
  }

  function init() {
    initArch();
    var days = initialDays();
    decorateLinks(days);
    setActiveBtn(days);

    // Pick a live applier for the diagram or the cake; detail pages have neither
    // and fall through to navigate-on-change.
    var data = null, canvas = null, live = null;
    var diagramRoot = document.querySelector('[data-se-diagram]');
    if (diagramRoot) {
      var dataEl = diagramRoot.querySelector('#se-graph-data');
      canvas = diagramRoot.querySelector('.se-diagram__canvas');
      if (dataEl && canvas) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; } }
      if (data && data.nodes && data.nodes.length) {
        layout(canvas, data);
        live = function (d) { applyDiagram(canvas, data, d); };
      }
    } else if (document.querySelector('[data-se-arch]')) {
      live = applyCake;
    }

    if (live) live(days);

    var bar = document.querySelector('[data-se-range]');
    if (bar) {
      Array.prototype.forEach.call(bar.querySelectorAll('.se-range__btn'), function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-days'), 10) || 0;
          if (live) {
            days = d;
            live(d); setActiveBtn(d); decorateLinks(d);
            try { window.history.replaceState(null, '', withSince(d)); } catch (e) { /* ignore */ }
          } else {
            window.location.assign(withSince(d));   // detail pages re-render server-side
          }
        });
      });
    }

    if (canvas && data && live) {
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { layout(canvas, data); live(days); }, 160);
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
